import { render, staticRenderFns } from "./ZGRanking2.vue?vue&type=template&id=3e508fbc&scoped=true"
import script from "./ZGRanking2.vue?vue&type=script&lang=js"
export * from "./ZGRanking2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e508fbc",
  null
  
)

export default component.exports